import { createRouter, createWebHistory } from "vue-router";

import { useIntegrationStore } from "@/stores/integration";
import { authGuard } from "@/router/guard";
import AppLayout from "@/layout/AppLayout.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      component: AppLayout,
      children: [
        {
          path: "/",
          name: "Home",
          meta: {
            breadcrumb: ["Home"],
          },
          component: () => import("@/pages/CreateRequest.vue"),
        },

        {
          path: "/create",
          name: "Create Automation",
          meta: {
            breadcrumb: ["Create Automation"],
          },
          component: () => import("@/pages/CreateAutomation.vue"),
        },
        {
          path: "/create-flow",
          name: "Create Flow",
          meta: {
            breadcrumb: ["Create Flow"],
          },
          component: () => import("@/pages/flows/FlowCreate.vue"),
        },
        {
          path: "/flows",
          name: "Flows",
          meta: {
            breadcrumb: ["Flow"],
          },
          component: () => import("@/pages/flows/FlowTableView.vue"),
        },
        {
          path: "/flows/:id",
          name: "Flow",
          meta: {
            breadcrumb: ["Flow"],
          },
          component: () => import("@/pages/flows/FlowEdit.vue"),
        },
        {
          path: "/assistants",
          name: "Assistants",
          meta: {
            breadcrumb: ["Assistants"],
          },
          component: () => import("@/pages/Assistants.vue"),
        },
        {
          path: "/automations",
          name: "Automations",
          meta: {
            breadcrumb: ["Automations"],
          },
          component: () => import("@/pages/triggers/TriggerTableView.vue"),
        },
        {
          path: "/automations/:id",
          name: "Automation",
          meta: {
            breadcrumb: ["Automation"],
          },
          component: () => import("@/pages/triggers/TriggerEdit.vue"),
        },
        {
          path: "/create-trigger",
          name: "Create Trigger",
          meta: {
            breadcrumb: ["Create Trigger"],
          },
          component: () => import("@/pages/triggers/TriggerCreate.vue"),
        },
        {
          path: "/integrations",
          name: "Integrations",
          meta: {
            breadcrumb: ["Integrations"],
          },
          component: () => import("@/pages/Integrations.vue"),
        },
        {
          path: "/auth/callback/:integrationShortName",
          name: "IntegrationAuthCallback",
          meta: {
            breadcrumb: ["Integration Auth Callback"],
          },
          component: () => {
            const integrationStore = useIntegrationStore();
            if (integrationStore.returnLocation === "automation") {
              return import("@/pages/CreateAutomation.vue");
            }
            return import("@/pages/Integrations.vue");
          },
        },
      ],
    },
    {
      path: "/terms-of-use",
      name: "Terms of Use",
      meta: {
        breadcrumb: ["Terms of Use"],
        requiresAuth: false,
      },
      component: () => import("@/pages/administrative/TermsOfUse.vue"),
    },
    {
      path: "/privacy-policy",
      name: "Privacy Policy",
      meta: {
        breadcrumb: ["Privacy Policy"],
        requiresAuth: false,
      },
      component: () => import("@/pages/administrative/PrivacyPolicy.vue"),
    },
    {
      path: "/login",
      name: "Login",
      meta: {
        breadcrumb: ["Login"],
        requiresAuth: false,
      },
      component: () => import("@/pages/auth/Login.vue"),
    },
    {
      path: "/login-handler",
      name: "Login Handler",
      meta: {
        breadcrumb: ["Login Handler"],
        requiresAuth: false,
      },
      component: () => import("@/pages/auth/LoginHandler.vue"),
    },
    {
      path: "/landing",
      name: "landing",
      component: () => import("@/pages/Landing.vue"),
    },
    {
      path: "/:pathMatch(.*)*",
      name: "notfound",
      component: () => import("@/pages/NotFound.vue"),
    },
  ],
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});

router.beforeEach(authGuard);

export default router;
